<template>
  <div class="atividades-tabelaalterada ml-4 mr-4">
    <b-form>
      <b-row>
        <!-- -->
        <!-- filial-->
        <b-col cols="3">
          <label for="input-filial">Filial</label>
          <div>
            <b-form-select
              id="filial"
              v-model="valor_filial"
              required
              :options="filiais"
              class="mb-3"
              text-field="filial"
              @change="loadSptrans()"
            >
            </b-form-select>
          </div>
        </b-col>

        <b-col cols="2">
          <label for="select-garagem">Status Sptrans</label>
          <multiselect
            v-model="value_sptrans"
            required
            :options="sptransx"
            :multiple="true"
            :close-on-select="false"
            :clear-on-select="true"
            :preserve-search="true"
            placeholder="Status"
            label="status"
            track-by="status"
            name="status"
            :preselect-first="true"
          >
            <template slot="selection" slot-scope="{ values, isOpen }"
              ><span
                class="multiselect__single"
                v-if="values.length &amp;&amp; !isOpen"
                >{{ values.length }} Status selecionado</span
              ></template
            >
          </multiselect>
        </b-col>

        <b-col cols="2">
          <div>
            <label for="datepicker-placeholder">Data escala</label>
            <b-form-datepicker
              id="datepicker-placeholder"
              v-model="data_servico"
              required
              placeholder="Selecione uma data"
              initial-date
              locale="pt-BR"
              date-format-options="DD/MM/YYYY"
            ></b-form-datepicker>
          </div>
        </b-col>

        <b-col>
          <br />
          <b-button
            size="sm"
            variant="primary"
            class="mr-2 mt-2"
            :disabled="carregando"
            @click="(carregando = true), loadTabelaAlteradas()"
          >
            <b-spinner v-if="carregando" small style="margin-bottom: 3px">
            </b-spinner>
            Pesquisar
          </b-button>
        </b-col>
      </b-row>
    </b-form>

    <b-col>
      <div>
        <b-progress :max="barra_limite">
          <b-progress-bar
            variant="success"
            :value="barra_inicial"
            :label="`${((barra_inicial / barra_limite) * 100).toFixed(2)} %`"
          ></b-progress-bar>
        </b-progress>
      </div>
    </b-col>

    <div class="d-flex justify-content-center mb-3">
      <b-spinner v-if="atualizando" label="Loading..."></b-spinner>
    </div>
    <!--tbl de dados -->
    <b-table
      id="sptalteracoes"
      small
      hover
      striped
      sticky-header="900px"
      :items="tabelaalteradas"
      :fields="fields"
    >
      <template slot="cell(actions)" slot-scope="data">
        <b-button
          :disabled="atualizando"
          @click="
            (atualizando = true),
              loadCarregaTabela(data.item),
              putTabelaAlteradas(),
              loadTabelaAlteradas()
          "
          title="Informar Sptrans"
          size="sm"
          variant="primary"
          class="mr-2 mt-2"
        >
          <i class="fa fa-exclamation-circle"></i>
        </b-button>
      </template>
    </b-table>
  </div>
</template>


<script>
import { baseApiUrl } from "@/global";
import axios from "axios";
import Multiselect from "vue-multiselect";
import moment from "moment";
import { mapState } from "vuex";

export default {
  name: "TrafegoTabelaAlterada",

  computed: { ...mapState(["user"]) },

  data: function () {
    return {
      mode: "save",
      carregando: false,
      atualizando: false,

      filiais: [],
      valor_filial: [], // [] lista
      tabelaalteradas: [], // [] lista
      tabelaalterada: {},

      garagem: {},
      garagens: [], // [] lista
      sptrans: {},
      sptransx: [], // [] lista
      value_sptrans: [], // [] lista

      modalidade: {},
      modalidades: [], // [] lista
      value_modalidade: [], // [] lista

      tabelaalterada: {}, // [] lista
      data_servico: "",

      barra_inicial: 0,
      barra_limite: 300000,

      fields: [
        { key: "id", label: "Id", sortable: true },
        { key: "id_filial", label: "Garagem", sortable: true },
        {
          key: "dt_alteracao",
          label: "Data alteração",
          sortable: true,
          formatter: (value, key, tabelaalteradas) => {
            return moment(tabelaalteradas.dt_alteracao)
              .format("DD/MM/YYYY - HH:mm")
              .replace("Data inválida", "-");
          },
        },

        //{ key: 'modalidade', label: 'Modalidade', sortable: true },
        { key: "linha", label: "Linha", sortable: true },
        { key: "tabela", label: "Tabela", sortable: true },
        { key: "hora_linha", label: "Hora Linha", sortable: true },

        { key: "carro_programado", label: "Carro Programado", sortable: true },
        {
          key: "motorista_prog",
          label: "Motorista Programado",
          sortable: true,
        },
        {
          key: "cobrador_programado",
          label: "Cobrador Programado",
          sortable: true,
        },

        { key: "carro_realizado", label: "Carro Alterado", sortable: true },
        {
          key: "motorista_realizado",
          label: "Motorista Alterado",
          sortable: true,
        },
        {
          key: "cobrador_realizado",
          label: "Cobrador Alterado",
          sortable: true,
        },

        { key: "id_origem", label: "Origem", sortable: true },
        //{ key: 'alterado_por', label: 'Alterado Por', sortable: true },
        { key: "status", label: "Status Sptrans", sortable: true },

        {
          key: "dt_sptrans",
          label: "Data Sptrans",
          sortable: true,
          formatter: (value, key, tabelaalteradas) => {
            return moment(tabelaalteradas.dt_sptrans)
              .format("DD/MM/YYYY HH:mm")
              .replace("Data inválida", "-");
          },
        },

        { key: "actions", label: "Ações" },
      ],
    };
  },

  components: {
    Multiselect,
  },
  methods: {
    //barra de progresso
    ready() {
      this.handle = setInterval(() => {
        this.barra_inicial = this.barra_inicial + 1000;
        if (this.barra_inicial >= this.barra_limite) {
          this.barra_inicial = 0;
          this.loadTabelaAlteradas();
        }
      }, 1000);
    },

    async loadFiliais() {
      let params = {
        id_grupo_empresa: `${this.user.id_grupo_empresa}`,
        id_empresa: this.user.id_empresa, // Verifica se há empresas e junta os ids como string
        psg: this.user.psg, // 12/04/2024 AS 12:16h enquanto não migrar 100% para a base da via Sudeste
      };
      const url = await `${baseApiUrl}/ctr/empresa/filial`;
      axios.get(url, { params }).then((res) => {
        this.filiais = res.data.map((filial) => {
          return { id_filial_erp: filial.id_filial_erp, filial: filial.filial };
        });
      });
    },

    loadModalidade() {
      const url = `${baseApiUrl}/trafego/modalidade`;
      axios.get(url).then((res) => {
        this.modalidades = res.data.map((modalidade) => {
          return {
            id_modalidade: modalidade.id_modalidade,
            modalidade: modalidade.modalidade,
          };
        });
      });
    },

    loadSptrans() {
      const url = `${baseApiUrl}/trafego/sptrans`;
      axios.get(url).then((res) => {
        this.sptransx = res.data.map((sptrans) => {
          return { id_status: sptrans.id_status, status: sptrans.status };
        });
      });
    },

    loadTabelaAlteradas() {
      //const url = `${baseApiUrl}/trafego/tabelaalterada/${[this.value_garagem.map(a => a.id_filial)]},${this.value_modalidade.id_modalidade},${this.value_sptrans.id_status},${this.data_servico}`

      let corpo = {
        id_filial: `${[this.valor_filial]}`,
        //    "id_modalidade": `${[this.value_modalidade.map(m => m.id_modalidade)]}`,
        id_status: `${[this.value_sptrans.map((s) => s.id_status)]}`,
        dt_servico: `${this.data_servico}`,
      };
      const url = `${baseApiUrl}/trafego/tabelaalterada`;
      axios.post(url, corpo).then((res) => {
        this.carregando = false;
        this.tabelaalteradas = res.data.map((tabelaalterada) => {
          return { ...tabelaalterada };
        });
      });
    },

    loadCarregaTabela(tabelaalterada) {
      this.tabelaalterada = { ...tabelaalterada };
    },

    putTabelaAlteradas() {
      let corpo = {
        //"id_filial": `${[this.valor_filial]}`,
        //    "id_modalidade": `${[this.value_modalidade.map(m => m.id_modalidade)]}`,
        //    "id_status": `${[this.value_sptrans.map(s => s.id_status)]}`,
        id: `${this.tabelaalterada.id}`,
      };
      const url = `${baseApiUrl}/trafego/sptrans/alterada`;
      axios.post(url, corpo).then((res) => {
        this.carregando = false;
        this.atualizando = false;
        this.tabelaalterada = res.data;
      });
    },
  },

  mounted() {
    this.loadFiliais();
    this.loadSptrans();
    //    this.loadGaragens()
    //   this.loadModalidade()
    //    this.loadTabelaAlteradas()
    //   this.putTabelaAlteradas()
    //    this.ready()
    // destroyed()
  },
};
</script>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<style>
.table {
  font-size: 0.8em;
  text-align: center;
}
</style>